import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { SortDirection } from '@e-origin/shared';

const c = initContract();

export const TransactionTypeResponseItem = z.object({
  _id: z.any().optional(),
  typeId: z.number(),
  name: z.string(),
  maxValue: z.number().optional(),
  createdAt: z.string().or(z.date()).optional(),
  updatedAt: z.string().or(z.date()).optional(),
});

export type TransactionTypeResponseItem = z.infer<typeof TransactionTypeResponseItem>;

export const transactionTypeContract = c.router({
  retrieveTransactionTypes: {
    method: 'POST',
    path: '/transaction-type',
    body: z.object({
      criteria: z
        .object({
          filters: z.object({ searchQuery: z.string().optional() }).optional(),
          pagination: z.object({ page: z.number().optional(), size: z.number().optional() }).optional(),
          sorting: z.object({ field: z.string().optional(), direction: z.enum([SortDirection.ASC, SortDirection.DESC]).optional() }).optional(),
        })
        .optional(),
    }),
    responses: {
      200: z.object({
        data: z.object({
          transactionTypes: z.array(TransactionTypeResponseItem),
          totalItems: z.number(),
        }),
      }),
    },
  },
  createTransactionType: {
    method: 'POST',
    path: '/transaction-type/add',
    body: z.object({
      typeId: z.number(),
      name: z.string(),
      maxValue: z.number().optional(),
    }),
    responses: {
      201: z.object({ data: TransactionTypeResponseItem }),
    },
  },
  createMultipleTransactionTypes: {
    method: 'POST',
    path: '/transaction-type/add-multi',
    body: z.object({
      types: z.array(
        z.object({
          typeId: z.number(),
          name: z.string(),
          maxValue: z.number().optional(),
        }),
      ),
    }),
    responses: {
      201: z.object({}),
    },
  },
  editTransactionType: {
    method: 'POST',
    path: '/transaction-type/edit/:id',
    pathParams: z.object({ id: z.string() }),
    body: z.object({
      name: z.string().optional(),
      typeId: z.number().optional(),
      maxValue: z.number().optional(),
    }),
    responses: {
      201: z.object({ data: TransactionTypeResponseItem.nullable() }),
    },
  },
  deleteTransactionType: {
    method: 'DELETE',
    path: '/transaction-type/:id',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({}),
    },
  },
  exportTransactionType: {
    method: 'POST',
    path: '/transaction-type/export-transaction-type/:transactionTypeId',
    pathParams: z.object({ transactionTypeId: z.string() }),
    body: c.noBody(),
    responses: {
      200: c.otherResponse({ contentType: 'application/json', body: z.any() }),
    },
  },
  importTransactionType: {
    method: 'POST',
    path: '/transaction-type/import-transaction-type',
    body: c.noBody(),
    responses: {
      201: z.object({ message: z.string() }),
    },
  },
});
